import { UIKitIcon } from '../icon';

export const thumbnailsIcon: UIKitIcon = {
  name: 'thumbnails',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g transform="translate(-1191 -785)">'
  + '<g transform="translate(1199 793)" fill="none" stroke="inherit" stroke-width="1"><rect width="7" height="7" stroke="none"/></g><g '
  + 'transform="translate(1199 802)" fill="none" stroke="inherit" stroke-width="1"><rect width="7" height="7" stroke="none"/></g><g '
  + 'transform="translate(1208 793)" fill="none" stroke="inherit" stroke-width="1"><rect width="7" height="7" stroke="none"/></g><g '
  + 'transform="translate(1208 802)" fill="none" stroke="inherit" stroke-width="1"><rect width="7" height="7" stroke="none"/></g></g>'
  + '</svg>',
};
